import PersonWithSuspense from "../Common/MicrosoftGraph/MgtPerson";

function ShowSharedPerms({ isTemplate, owner, coOwners, sharedPermission }) {
  return (
    <>
      <div className="k-mt-1">
        <strong>Owner: </strong>
        <span className="k-mr-3">
          <PersonWithSuspense email={owner} />
        </span>
      </div>
      {coOwners?.length > 0 && (
        <div className="k-mt-1">
          <strong>Co-Owners: </strong>

          {coOwners.map((coOwner) => (
            <span
              key={coOwner.user}
              className="k-mr-3"
            >
              {coOwner.isUserGroup || coOwner.userGroupId ? (
                <div
                  key={coOwner.user}
                  className="k-mt-1"
                >
                  📁 {coOwner.user} (User Group)
                </div>
              ) : (
                <PersonWithSuspense email={coOwner.user} />
              )}
            </span>
          ))}
        </div>
      )}
      {sharedPermission?.filter((sp) => sp.permission === "View").length > 0 && (
        <div className="k-mt-1">
          <strong>View Permissions: </strong>
          {sharedPermission
            ?.filter((sp) => sp.permission === "View")
            ?.map((spItem) => (
              <span
                key={spItem.entity}
                className="k-mr-3"
              >
                {spItem.isUserGroup || spItem.userGroupId ? (
                  <div
                    key={spItem.entity}
                    className="k-mt-1"
                  >
                    📁 {spItem.entity} (User Group)
                  </div>
                ) : (
                  <PersonWithSuspense email={spItem.entity} />
                )}
              </span>
            ))}
        </div>
      )}
      {sharedPermission?.filter((sp) => sp.permission === "Modify").length > 0 && (
        <div className="k-mt-1">
          <strong>Modify Permissions: </strong>
          {sharedPermission
            ?.filter((sp) => sp.permission === "Modify")
            ?.map((spItem) => (
              <span
                key={spItem.entity}
                className="k-mr-3"
              >
                {spItem.isUserGroup || spItem.userGroupId ? (
                  //<span>📁 {spItem.entity} (User Group)</span>
                  <div
                    key={spItem.entity}
                    className="k-mt-1"
                  >
                    📁 {spItem.entity} (User Group)
                  </div>
                ) : (
                  <PersonWithSuspense email={spItem.entity} />
                )}
              </span>
            ))}
        </div>
      )}
      {isTemplate &&
        sharedPermission?.filter(
          (sp) =>
            sp.permission === "MakeEntry" ||
            sp.permission === "ViewAuthorOnly" ||
            sp.permission === "ViewBusinessUnitOnly"
        ).length > 0 && (
          <div className="k-mt-1">
            <strong>Make Entry Permissions: </strong>
            {sharedPermission
              ?.filter(
                (sp) =>
                  sp.permission === "MakeEntry" ||
                  sp.permission === "ViewAuthorOnly" ||
                  sp.permission === "ViewBusinessUnitOnly"
              )
              ?.map((spItem) => (
                <span
                  key={spItem.entity}
                  className="k-mr-3"
                >
                  {spItem.isUserGroup || spItem.userGroupId ? (
                    <div
                      key={spItem.entity}
                      className="k-mt-1"
                    >
                      📁 {spItem.entity} (User Group)
                    </div>
                  ) : (
                    <PersonWithSuspense email={spItem.entity} />
                  )}
                </span>
              ))}
          </div>
        )}
    </>
  );
}

export default ShowSharedPerms;
